import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft } from '@phosphor-icons/react';
import QuotationForm from '../components/QuotationForm';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CreateQuotation() {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (data) => {
    setSaving(true);
    try {
      await axios.post(`${API}/quotations`, data);
      navigate('/');
    } catch (e) {
      console.error(e);
      alert('Failed to create quotation');
    } finally { setSaving(false); }
  };

  return (
    <div>
      <button onClick={() => navigate('/')} data-testid="back-to-quotations"
        className="inline-flex items-center gap-1.5 text-stone-500 hover:text-stone-800 text-sm font-medium mb-6 transition-colors">
        <ArrowLeft size={16} /> Back
      </button>
      <h1 className="text-3xl sm:text-4xl text-stone-900 mb-8" data-testid="create-quotation-title">New Quotation</h1>
      <QuotationForm onSubmit={handleSubmit} submitLabel="Create Quotation" saving={saving} />
    </div>
  );
}
